var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"boolean-renderer renderer-string-content"},[_vm._v(_vm._s(_vm.displayBoolean(_vm.value)))])
}
var staticRenderFns = []

export { render, staticRenderFns }